export default __webpack_public_path__ + "static/HR-13666f5586c0a3eb3fbd7978c172ce35.png";